module.exports = __webpack_public_path__ + "img/square-silver-logo-large.06b3fbd1.png";